/* eslint-disable max-len */
import React from "react";
import styles from "./about.module.scss";
import Blockchain from "@assets/images/blockchain.jpg";
import AI from "@assets/images/ai.jpg";
import Cloud from "@assets/images/cloud.jpg";
import VolumetricLogo from "@assets/images/volumetric360.png";
import { Carousel } from "../../components/carousel/Carousel.component";
import { GlassCard } from "../../components/glass-card/GlassCard.component";
import { separator01 } from "../../utils/svg";
import { SeoComponent } from "../../components/seo/Seo.component";

export const About: React.FC = () => {
  const projectSlides = projects.map((project, index) => (
    <GlassCard key={index} image={project.image}>
      <project.text />
    </GlassCard>
  ));

  return (
    <div className={styles["about"]}>
      <SeoComponent
        title="About | Volumetric"
        description="Learn about Volumetric Labs, our mission, and our team of passionate engineers dedicated to building the future of the web."
      />
      <div className={styles["intro-section"]}>
        <div className={styles["title-wrapper"]}>
          <h1 className={styles["section-title"]}>About Us</h1>
        </div>
        <AboutIntro />
      </div>

      <div className={styles["showcase-section"]}>
        <div className={styles["title-wrapper"]}>
          <h2 className={styles["section-title"]}>Project Showcase</h2>
        </div>
        <ShowcaseIntro />
        <Carousel items={projectSlides} />
      </div>
    </div>
  );
};

const AboutIntro: React.FC = () => {
  return (
    <>
      <div className={styles["text-container"]}>
        <p>
          Volumetric Labs was founded on the belief that technology should be a
          force for good. We are a team of passionate engineers, designers, and
          strategists who are dedicated to building the future of the web.
        </p>
        <div className={styles["separator-container"]}>
          <svg viewBox="0 0 767 100" className={styles["separator"]}>
            <path d={separator01} />
          </svg>
        </div>
        <p>
          With a focus on transparency, security, and user-centric design, we
          help our clients navigate the complex landscape of modern technology.
          From blockchain to AI, we have the expertise to turn your vision into
          reality.
        </p>
      </div>
      <img
        id="about-logo"
        src={VolumetricLogo}
        alt="Volumetric Labs"
        className={styles["about-logo"]}
      />
    </>
  );
};

const ShowcaseIntro: React.FC = () => {
  return (
    <div className={styles["text-container"]}>
      <p>
        From decentralized finance protocols to enterprise-grade AI agents, our
        portfolio reflects our versatility and technical depth. We don't just
        deliver code; we deliver competitive advantages.
      </p>
    </div>
  );
};

const project1: React.FC = () => {
  return (
    <>
      <p>
        <strong>DeFi Analytics Dashboard</strong>
      </p>
      <p>
        We built a comprehensive analytics dashboard for a leading DeFi
        protocol. The platform aggregates data from multiple blockchains,
        providing users with real-time insights into liquidity pools, trading
        volumes, and yield farming opportunities.
      </p>
    </>
  );
};

const project2: React.FC = () => {
  return (
    <>
      <p>
        <strong>AI-Powered Customer Support</strong>
      </p>
      <p>
        For a global e-commerce brand, we developed an AI-powered customer
        support agent capable of handling complex queries in multiple languages.
        The system reduced response times by 80% and significantly improved
        customer satisfaction scores.
      </p>
    </>
  );
};

const project3: React.FC = () => {
  return (
    <>
      <p>
        <strong>Cloud Infrastructure Migration</strong>
      </p>
      <p>
        We successfully migrated a legacy enterprise application to a modern,
        cloud-native architecture. The new system is highly scalable, secure,
        and cost-effective, allowing the client to handle peak traffic loads
        with ease.
      </p>
    </>
  );
};

const projects = [
  { image: Blockchain, title: "DeFi Dashboard", text: project1 },
  { image: AI, title: "AI Support Agent", text: project2 },
  { image: Cloud, title: "Cloud Migration", text: project3 },
];
